import { useState } from 'react';
import s from './create-job-title-modal.module.css';
import { Button } from '../../../../../../../../components/button/button';
import { Input } from '../../../../../../../../components/input/input';
import { ModalProps, Modal } from '../../../../../../../../components/modal/modal';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useTagStaffStore } from '../../../../../../../../store/use-tag-staff-store';

export const CreateJobTitleModal = (props: ModalProps) => {
  const { t } = useLang();
  const { postTag, isLoading } = useTagStaffStore();
  const [name, setName] = useState('');

  const handleCreate = async () => {
    await postTag(name)
      .then(props.onClose)
      .then(() => setName(''));
  };

  return (
    <Modal {...props} title={t('Создать должность')} className={s.feature}>
      <Input
        value={name}
        onChange={(e) => setName(e.currentTarget.value)}
        data-testid="name-input"
      />
      <div className={s.controls}>
        <Button
          variant="secondary"
          onClick={props.onClose}
          disabled={isLoading}
          data-testid="cancel-button"
        >
          {t('Отменить')}
        </Button>
        <Button
          onClick={handleCreate}
          disabled={isLoading || name.length < 3}
          data-testid="submit-button"
        >
          {t('Создать')}
        </Button>
      </div>
    </Modal>
  );
};
